"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../helpers");
exports.addComment = function (comment) {
    return {
        type: 'ADD_COMMENT',
        comment: comment,
    };
};
exports.addComments = function (comments) {
    return {
        type: 'ADD_COMMENTS',
        comments: comments,
    };
};
exports.removeComment = function (uid) {
    return {
        type: 'REMOVE_COMMENT',
        uid: uid,
    };
};
exports.comments = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case 'ADD_COMMENT':
            var comment = __assign(__assign({}, action.comment), { content: helpers_1.escapeHtml(action.comment.content) });
            return __spreadArrays([comment], state);
        case 'ADD_COMMENTS':
            action.comments.forEach(function (c) {
                c.content = helpers_1.escapeHtml(c.content);
            });
            return action.comments;
        case 'REMOVE_COMMENT':
            return state.filter(function (c) { return c.uid !== action.uid; });
        default:
            return state;
    }
};
